<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: {
            ...mapGetters({
                project: 'getProject'
            })
        },
        methods: {
            loadProject() {
                let project = this.$route.params.project;
                if (typeof project !== "undefined") {
                    return this.$store.dispatch('findProject', {
                            project: project
                        }
                    );
                }
            },
        }
    }
</script>
